module.exports = __webpack_public_path__ + "img/set-yourself.25ab7ceb.png";